import showModal from '../../scripts/modal'
import $ from 'jquery'

export default function () {
  // Show modal
  const manual = document.getElementById('manual')
  const $link = $('.header__link-manual')
  $link.on('click', function (e) {
    // e.preventDefault()
    // showModal(manual)
    // if (window.history && window.history.pushState) {
    //   history.pushState('', document.title, $(this).attr('href'))
    // }
  })

  // Switch articles
  const $switch = $('.manual__link')
  $switch.on('click', function (e) {
    const $this = $(this)
    e.preventDefault()
    $($this.attr('href')).addClass('active').siblings().removeClass('active')
    $this.addClass('active').siblings().removeClass('active')
  })
}



// WEBPACK FOOTER //
// ./app/blocks/manual/manual.js